import React, {useState} from 'react';
import useFetchFavouriteJobs from '../../../hooks/useFetchFavouriteJobs';
import FavouriteJobCard from './FavouriteJobCard';
import './favouritejobsView.css';
import Loading from '../Loading/Loading';

const FavouriteJobsView = () => {
    const [flashMessage, setFlashMessage] = useState('')
    const { favouriteJobs, loading, error, fetchFavouriteJobs, triggerFetchFavouriteJobs } = useFetchFavouriteJobs();


    const onDeleteSuccess = () => {
       triggerFetchFavouriteJobs()
       displayFlashMessage('Trabajo favorito eliminado')
    }
    
    const displayFlashMessage = (message) => {
        setFlashMessage(message);
        setTimeout(() => {
          setFlashMessage(null);
        }, 3000); 
    };

    return (
        <>
            {flashMessage && (
                <div className="flash-message">
                  <p>{flashMessage}</p>
                </div>
            )}
        
            <div className="favourite-jobs-view__container">
                <h1>Trabajos favoritos</h1>

                {loading && <><Loading/></>}

                <div className="favourite-jobs-view__cards-container">
                    {Array.isArray(favouriteJobs) && favouriteJobs.length > 0 ? (
                        favouriteJobs.map((job) => (
                            <FavouriteJobCard key={job.id} data={job} onDeleteSuccess={onDeleteSuccess}/>
                        ))
                    ) : (
                        !loading && (
                            <div className="no-favorite-jobs-message">
                                <p>No tienes trabajos guardados como favoritos aún.</p>
                            </div>
                        )
                    )}
                </div>
            </div>
        </>
    );
};

export default FavouriteJobsView;


